export const storagePageSizeConstant = (entity: string) => `is2/${entity}PageSize`
